<template>
  <div class="contact-float-container">
    <!-- 悬浮按钮 -->
    <div class="contact-float-btn" @click="handleClick">
      <SvgImage1 height="27" width="27" />
      <div class="contact-float-text">
        {{ $t("contactFloat.onlineContact") }}
      </div>
      <div class="contact-float-text-active">
        {{ $t("contactFloat.onlineContact2") }}
      </div>
    </div>
    <div class="contact-float-btn" @click="handleClick2">
      <SvgImage2 height="27" width="27" />
      <div class="contact-float-text">
        {{ $t("contactFloat.phoneContact") }}
      </div>
      <div class="contact-float-text-active">+86-18968921608</div>
    </div>
    <div
      class="contact-float-btn"
      @mouseenter="showContactInfo = true"
      @mouseleave="showContactInfo = false"
    >
      <SvgImage3 />
      <div class="contact-float-text">
        {{ $t("contactFloat.wechatConsult") }}
      </div>
      <div class="contact-float-text-active">
        {{ $t("contactFloat.scanToAdd") }}
      </div>
      <div class="contact-float-text-active">
        {{ $t("contactFloat.kunbuRobot") }}
      </div>
    </div>
    <!-- 联系信息弹窗 -->
    <div class="contact-info-popup" v-show="showContactInfo">
      <!-- 联系电话 -->
      <!-- <div class="contact-item">
        <div class="contact-label">{{ $t('contactFloat.contactPhone') }}</div>
        <div class="contact-value">+86-18968921608</div>
      </div> -->

      <!-- 微信二维码 -->
      <div class="contact-item">
        <!-- <div class="contact-label">{{ $t('contactFloat.wechatQRCode') }}</div> -->
        <div class="qrcode-container">
          <!-- 这里可以替换为实际的微信二维码图片 -->
          <img
            :src="qrcode"
            alt="WeChat QR Code"
            width="100%"
            height="100%"
            style="border: none"
          />
        </div>
      </div>
    </div>

    <!-- 确保按钮和弹窗之间有一个连接区域，鼠标可以顺利移动 -->
    <div class="contact-connection-area" v-show="showContactInfo"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { Phone } from "@element-plus/icons-vue";
import qrcode from "@/assets/qrcode.png";
import SvgImage1 from "@/assets/icon1.svg?component";
import SvgImage2 from "@/assets/icon2.svg?component";
import SvgImage3 from "@/assets/icon3.svg?component";
import { useRouter } from "vue-router";

const router = useRouter();
// 控制联系信息是否显示
const showContactInfo = ref(false);

// 控制组件的位置
const isScrolled = ref(false);

// 滚动事件处理函数
const handleScroll = () => {
  // 当滚动距离大于100px - 70px = 30px时，切换到固定位置
  isScrolled.value = window.scrollY > 30;
};
const handleClick = () => {
  router.push("/cooperation");
  const targetElement = document.querySelector(".navbar");
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
const handleClick2 = () => {
  window.location.href = "tel:+86-18968921608";
};

// 生命周期钩子
onMounted(() => {
  // 初始检查滚动位置
  handleScroll();
  // 添加滚动事件监听
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  // 移除滚动事件监听
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.contact-float-container {
  position: fixed;
  /* 初始top值由动态样式控制 */
  top: 50%;
  right: 20px;
  /* 移除transform，直接使用top控制垂直位置 */
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* 添加过渡效果，使位置变化更平滑 */
  transition: top 0.3s ease;
}

.contact-float-btn {
  width: 70px;
  height: 70px;
  background-color: #222;
  /* border-radius: 50%; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  /* 确保按钮在最右侧 */
  position: relative;
  z-index: 1001;
  padding: 5px;
}
.contact-float-btn + .contact-float-btn {
  margin-top: 10px;
}
.contact-float-text {
  font-size: 14px;
  color: white;
}
.contact-float-text-active {
  color: white;
  display: none;
  /* 不换行 */
  white-space: nowrap;
}
.contact-float-btn:hover {
  background-color: #0056b3;
  width: 150px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  .contact-float-text-active {
    display: block;
  }
  .contact-float-text {
    display: none;
  }
  svg {
    display: none;
  }
}

.contact-icon {
  font-size: 24px;
  color: white;
}

.contact-info-popup {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 10px;
  background-color: #222;
  /* 增大弹窗宽度 */
  /* min-width: 280px; */
  /* 限制最大宽度，确保在小屏幕上不会太宽 */
  max-width: 90vw;
  /* 调整弹窗位置，使其紧挨着按钮左侧 */
  position: absolute;
  right: 160px; /* 按钮宽度 + 20px 间隙，确保有足够空间 */
  bottom: 0px;
  /* transform: translateY(-50%); */
  transition: all 0.3s ease;
  animation: fadeIn 0.3s ease;
  /* 确保弹窗在按钮左侧，并且与按钮对齐 */
  z-index: 1000;
}

/* 连接区域，确保鼠标可以顺利从按钮移动到弹窗 */
.contact-connection-area {
  position: absolute;
  right: 60px; /* 按钮右侧 */
  top: 50%;
  transform: translateY(-50%);
  width: 30px; /* 连接区域宽度 */
  height: 100%; /* 与按钮同高 */
  /* 透明背景，不影响视觉效果 */
  background-color: transparent;
  /* 确保在按钮和弹窗之间 */
  z-index: 999;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.contact-item {
  margin-bottom: 15px;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.contact-value {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}

.qrcode-container {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px solid #e0e0e0; */
  /* margin-top: 10px; */
}

/* .qrcode-placeholder {
  font-size: 14px;
  color: #999;
  text-align: center;
} */

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-float-text {
    display: none;
  }
  .contact-float-btn {
    width: 50px;
    height: 50px;
  }
  .contact-float-container {
    right: 8px;
  }
  .contact-icon {
    font-size: 20px;
  }

  .contact-info-popup {
    /* min-width: 180px; */
    padding: 15px;
  }

  .qrcode-container {
    width: 130px;
    height: 130px;
  }
}
</style>
